import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { PROMO_CODE_DISCOUNT_TYPES } from '../../services/exports/Constants';
import CurrencyInput from '../form/general/CurrencyInput';
import PercentageInput from '../form/general/PercentageInput';

export default function PromoCodeComponent({ discountType, data, update, remove, className }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:PromoCode:PromoCodeComponent' });

  const renderDiscount = () => {
    if (discountType === PROMO_CODE_DISCOUNT_TYPES.percentage) {
      return <PercentageInput value={data.discount} onChange={(value) => update('discount', value)} />;
    }

    return <CurrencyInput value={data.discount} onChange={(value) => update('discount', value)} />;
  };

  return (
    <div className={classnames('relative border-t border-solid border-brand-inkGrey-grey_2 py-md', className)}>
      <Button danger icon={<DeleteOutlined />} className="absolute top-0 right-0 -translate-y-1/2" onClick={remove} />
      <div className="p-md">
        <div className="flex">
          <span className="my-auto w-full">{t('fields.discount.label')}</span>
          {renderDiscount()}
        </div>
        <div className="mt-lg flex">
          <span className="my-auto w-full">{t('fields.usage_threshold.label')}</span>
          <CurrencyInput value={data.usage_threshold} onChange={(value) => update('usage_threshold', value)} />
        </div>
        {discountType === PROMO_CODE_DISCOUNT_TYPES.percentage && (
          <div className="mt-lg flex">
            <span className="my-auto w-full">{t('fields.max_discount.label')}</span>
            <CurrencyInput value={data.max_discount} onChange={(value) => update('max_discount', value)} />
          </div>
        )}
      </div>
    </div>
  );
}
